import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Container from '../components/shared/atoms/Container';
import Box from '../components/shared/atoms/Box';
import Heading from '../components/shared/atoms/Heading';
import Text from '../components/shared/atoms/Text';
import Button from '../components/shared/atoms/Button';

function ConfirmationError() {
  const { t } = useTranslation();
  const history = useHistory();
  const [countdown, setCountdown] = useState(5);
  const [errorReason, setErrorReason] = useState('');

  useEffect(() => {
    // Get error reason from URL
    const urlParams = new URLSearchParams(window.location.search);
    const reason = urlParams.get('reason');
    if (reason) {
      setErrorReason(decodeURIComponent(reason));
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          history.push('/reparation');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [history]);

  return (
    <Container>
      <Helmet
        title={t('confirmation.error.meta.title', 'Erreur de confirmation')}
        meta={[{ name: 'robots', content: 'noindex, nofollow' }]}
      />
      <Container fluid py={10}>
        <Box
          maxWidth="600px"
          mx="auto"
          textAlign="center"
          bg="white"
          p={{ xs: 6, lg: 8 }}
          borderRadius="md"
          boxShadow="md">
          <Box
            width="80px"
            height="80px"
            borderRadius="full"
            bg="error.lighter"
            mx="auto"
            mb={4}
            alignItems="center"
            justifyContent="center">
            <Text fontSize="48px" lineHeight="1">
              ⚠️
            </Text>
          </Box>

          <Heading level={1} mb={3}>
            {t('confirmation.error.title', 'Erreur de confirmation')}
          </Heading>

          <Text variant="large" color="gray.darker" mb={4}>
            {t(
              'confirmation.error.description',
              "Nous n'avons pas pu confirmer votre course.",
            )}
          </Text>

          {errorReason && (
            <Box bg="error.lighter" p={3} borderRadius="xs" mb={4}>
              <Text variant="small" color="error.main">
                {errorReason}
              </Text>
            </Box>
          )}

          <Text variant="small" color="gray.dark" mb={6}>
            Vous serez redirigé vers la page de réparation dans {countdown}{' '}
            seconde{countdown > 1 ? 's' : ''}...
          </Text>

          <Button onClick={() => history.push('/reparation')} variant="primary">
            {t('confirmation.error.cta', 'Retour à la page de réparation')}
          </Button>
        </Box>
      </Container>
    </Container>
  );
}

export default ConfirmationError;
